import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const WiredInternetIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "WiredInternetIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.1846 13.5774H19.6455V7.24019C19.6455 5.17122 17.9683 3.49399 15.8993 3.49399C13.8304 3.49399 12.1531 5.17122 12.1531 7.24019V18.1019C12.1531 19.4805 11.0355 20.598 9.65691 20.5979C8.27845 20.5978 7.161 19.4804 7.16094 18.1019V12.5201H9.70001C10.0452 12.5201 10.325 12.2403 10.325 11.8951V6.32269C10.325 5.97751 10.0452 5.69769 9.70001 5.69769H8.78223V4.49667C8.78223 4.15149 8.50241 3.87167 8.15723 3.87167H4.97754C4.63236 3.87167 4.35254 4.15149 4.35254 4.49667V5.69769H3.43457C3.08939 5.69769 2.80957 5.97751 2.80957 6.32269V11.8951C2.80957 12.2403 3.08939 12.5201 3.43457 12.5201H5.91075V18.1018C5.91109 20.1707 7.58856 21.8476 9.65747 21.8472C11.7259 21.8469 13.4026 20.1702 13.403 18.1018V7.2402C13.403 5.86159 14.5205 4.744 15.8992 4.744C17.2778 4.744 18.3953 5.86158 18.3953 7.2402V13.5774H15.9192C15.574 13.5774 15.2942 13.8573 15.2942 14.2024V19.7751C15.2942 20.1202 15.574 20.4001 15.9192 20.4001H16.837V21.601C16.837 21.9461 17.1168 22.226 17.462 22.226H20.6416C20.9868 22.226 21.2666 21.9461 21.2666 21.601V20.4001H22.1846C22.5298 20.4001 22.8096 20.1202 22.8096 19.7751V14.2024C22.8096 13.8573 22.5298 13.5774 22.1846 13.5774ZM5.6023 5.12168H7.53199V5.6977H5.6023V5.12168ZM4.05956 6.9477H9.07484V11.2701H4.05957L4.05956 6.9477ZM20.0168 20.976H18.0869V20.4001H20.0166L20.0168 20.976ZM21.5596 19.1501H16.5443V14.8274H21.5596V19.1501Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default WiredInternetIcon;
